export const environment = {
  production: false,
  development: true,
  firebaseConfig: {
    projectId: 'cryptoid-dev',
    appId: '1:711850351683:web:e42171585e83652142c8f6',
    storageBucket: 'cryptoid-dev.appspot.com',
    apiKey: 'AIzaSyB-Y-D06ig1D5QWDo5ZdyDlxyRv_1He29o',
    authDomain: 'cryptoid-dev.firebaseapp.com',
    messagingSenderId: '711850351683',
    measurementId: 'G-54D3EDJDW9',
  },
}
